import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { YellowFontWithStroke } from '../fontStyles';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';

export default class PaytableContent extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.currentFrame = 1;
    this.addListeners();
  }

  addListeners() {
    GlobalDispatcher.add('paytable:backClick', this.reset, this);
    GlobalDispatcher.add('paytable:changePage', this.changeFrame, this);
  }

  update() {
    const title = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_0`);
    title.style = { ...title.style, ...YellowFontWithStroke };
    const startIndex = 3;

    switch (this.currentFrame) {
      case 1: {
        for (let i = 1; i <= 1; i++) {
          const text = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_${i}`);
          text.style = { ...text.style, ...YellowFontWithStroke };
        }
        break;
      }
      case 2: {
        for (let i = 1; i <= 1; i++) {
          const text = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_${i}`);
          if (text) text.style = { ...text.style, ...YellowFontWithStroke };
        }

        let amounts = [...EntryPoint.GameModel.paytableInfo[8]];
        amounts = amounts.slice(3, amounts.length);

        for (let i = 0; i < amounts.length; i++) {
          const count = this.children[0].getChildByName(`paytable_p1_count${i}`);
          const coeff = this.children[0].getChildByName(`paytable_p1_coefs${i}`);
          if (coeff) {
            coeff.text = amounts[i];
            count.text = `${startIndex + i}×`;
            count.style = { ...count.style, ...YellowFontWithStroke };
            coeff.style = { ...coeff.style, ...YellowFontWithStroke };
          }
        }
        break;
      }
      case 3: {
        break;
      }
      case 4: {
        for (let i = 0; i < 6; i++) {
          const count = this.children[0].getChildByName(`paytable_p3_count${i}`);
          const coeff = this.children[0].getChildByName(`paytable_p3_coefs${i}`);
          if (coeff) {
            let amounts = [...EntryPoint.GameModel.paytableInfo[i + 2]];
            amounts = amounts.slice(3, amounts.length);
            coeff.text = amounts.join('\n');
            count.text = amounts.map( (value, index) => `${startIndex + index}×`).join('\n');
          }
          count.style = { ...count.style, ...YellowFontWithStroke };
          coeff.style = { ...coeff.style, ...YellowFontWithStroke };
        }
        break;
      }
    }
  }

  changeFrame(event) {
    this.currentFrame = event.params || 1;
    this.goToFrame(this.currentFrame);
    this.update();
  }

  reset() {
    this.currentFrame = 1;
    this.goToFrame(this.currentFrame);
    this.update();
  }

  destroy() {
    GlobalDispatcher.remove('paytable:backClick', this.reset, this);
    GlobalDispatcher.remove('paytable:changePage', this.changeFrame, this);
    super.destroy();
  }

  goToFrame(index) {
    this.libName = index === 6 ? 'jackpotGameFlashLib' : 'GameFlashLib';
    super.goToFrame(index);
  }
}
